// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* 在el-dialog中tinymce z-index 被太小而被遮挡时要加这两句 */\n.tox-tinymce-aux{z-index:10000 !important;}\n.tinymce.ui.FloatPanel{z-Index: 99999;}\n\n", ""]);
// Exports
module.exports = exports;
